// extracted by mini-css-extract-plugin
export var fullWidthButton = "_rx-0";